import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
  const token = localStorage.getItem("authToken");
  const userRole = localStorage.getItem("userRole") || ""; // Get user's role
  
  console.log("ProtectedRoute: isAuthenticated:", isAuthenticated);
  console.log("ProtectedRoute: token exists:", !!token);
  console.log("ProtectedRoute: userRole:", userRole);
  
  // Si no hay token o no está autenticado, redirigir al login
  if (!isAuthenticated || !token) {
    // Limpiar localStorage si no hay token
    if (!token) {
      localStorage.removeItem("isAuthenticated");
      localStorage.removeItem("userRole");
      localStorage.removeItem("usuarioId");
      localStorage.removeItem("username");
      localStorage.removeItem("authToken");
    }
    return <Navigate to="/login" />;
  }
  
  // Check if user is authenticated and has the required role
  // If allowedRoles is empty array, any authenticated user can access
  const hasPermission = allowedRoles.length === 0 || allowedRoles.includes(userRole);
  
  if (!hasPermission) {
    // Redirect to an access denied page or default page for their role
    return <Navigate to={getRoleDefaultPage(userRole)} />;
  }
  
  return children;
};

const getRoleDefaultPage = (role) => {
  switch (role) {
    case "ROLE_OPERARIO":
      return "/appointments-pending";
    case "ROLE_MANAGER":
      return "/appointments-management";
    case "ROLE_ADMIN":
      return "/dashboard";
    case "ROLE_USER":
    default:
      return "/alarms";
  }
};

export default ProtectedRoute;